<template>
  <div class="login-wrapper" ref="wrapperRef">
    <div id="login" ref="contentRef">
      <HDFHeader03 />
    <main>
      <div class="login-form">
        <div class="login-ui-bg">
          <p>欢迎加入{{ APP_NAME }}</p>
          <el-form :model="form" label-width="auto" style="max-width: 400px">
            <el-form-item label="">
              <el-input v-model="form.userName" placeholder="请输入您的账号">
                <template #prefix>
                  <el-icon class="el-input__icon"><UserFilled /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item label="">
              <el-input v-model="form.password" type="password" placeholder="请输入您的密码" show-password>
                <template #prefix>
                  <el-icon class="el-input__icon"><Lock /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item label="">
              <div class="captcha-line">
                <el-input v-model="form.vcode" placeholder="请输入验证码" style="flex: 1;"></el-input>
                <img
                  v-if="captchaImg"
                  :src="captchaImg"
                  class="captcha-img"
                  alt="验证码"
                  @click="fetchCaptcha"
                  title="点击刷新验证码"
                />
              </div>
            </el-form-item>

            <el-form-item label="">
              <el-checkbox v-model="form.resource">我同意「{{ APP_NAME }}用户使用协议」</el-checkbox>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="onSignIn" class="sign-in-btn">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </main>
    <HDFFooter03 />
    </div>
  </div>
</template>

<script setup>
import HDFHeader03 from '@/components/HDFHeader03.vue'
import HDFFooter03 from '@/components/HDFFooter03.vue'
import { APP_NAME } from '@/utils/const'
import { reactive, ref, onMounted, onBeforeUnmount } from 'vue'
import { ElMessage } from 'element-plus'
import Router from '@/router/index'
import { LoginByPassword, GetCaptcha } from '@/api/api.js'
import { saveUserInfo, removeCacheAuthToken, getAuthHandel, removeAuthHandel, saveCacheToken } from '@/utils/common'

// ===================== 等比例缩放逻辑 =====================
const wrapperRef = ref(null)
const contentRef = ref(null)
const MAX_WIDTH = 1920 // 界面最大宽度
const SCALE_WIDTH = 1920 // 缩放基准宽度

const updateScale = () => {
  if (!wrapperRef.value || !contentRef.value) return
  
  const screenWidth = window.innerWidth
  
  if (screenWidth < SCALE_WIDTH) {
    // 小于1920px时进行等比例缩放
    const scale = screenWidth / SCALE_WIDTH
    
    // 设置容器高度为缩放后的实际高度
    const contentHeight = contentRef.value.scrollHeight
    wrapperRef.value.style.height = `${contentHeight * scale}px`
    
    // 应用缩放
    contentRef.value.style.transform = `scale(${scale})`
    contentRef.value.style.transformOrigin = 'top left'
    contentRef.value.style.margin = '0'
  } else {
    // 大于等于1920px时保持原始大小并居中
    wrapperRef.value.style.height = 'auto'
    contentRef.value.style.transform = 'none'
    contentRef.value.style.margin = '0 auto'
  }
}

const authParams = getAuthHandel()

const form = reactive({
  userName: '',
  password: '',
  vcode: '',
  resource: ''
})

const captchaImg = ref('')
const captchaUuid = ref('')

const fetchCaptcha = () => {
  GetCaptcha().then((response) => {
    const res = response.data
    if (res.code === 200) {
      captchaImg.value = 'data:image/jpeg;base64,' + res.img
      captchaUuid.value = res.uuid
      form.vcode = ''
    }
  }).catch(() => {
    captchaImg.value = ''
    captchaUuid.value = ''
  })
}

onMounted(() => {
  fetchCaptcha()
  updateScale()
  window.addEventListener('resize', updateScale)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScale)
})

const onSignIn = () => {
  if (!form.userName) {
    return ElMessage('请输入账号')
  }
  if (!form.password) {
    return ElMessage('请输入密码')
  }
  if (!form.vcode || !/^\d{1,6}$/.test(form.vcode)) {
    return ElMessage('请输入正确的验证码（1-6位数字）')
  }
  if (!form.resource) {
    return ElMessage('请勾选同意协议')
  }

  LoginByPassword({
    userName: form.userName,
    password: form.password,
    vcodeKey: captchaUuid.value,
    vcode: form.vcode
  }).then((response) => {
    const res = response.data;
    if (res.code === 200) {
      const userInfo = res.data;
      saveCacheToken(userInfo.token)
      saveUserInfo(userInfo);
      if(authParams){
        removeCacheAuthToken();
        if(userInfo.name){
          removeAuthHandel()
          window.location.href='/auth/handle'+authParams;
        }else{
          window.location.href='/personalInfo';
        }
      }else{
        // 整页刷新，确保导航按登录用户权限重新下发（needLogin/分组链接）
        if(userInfo.name){
          window.location.href='/'
        }else{
          window.location.href='/personalInfo'
        }
      }
    } else {
      fetchCaptcha()
    }
  }).catch(() => {
    fetchCaptcha()
  })
}
</script>

<style scoped>
.login-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

#login {
  width: 1920px;
  /* height: 100v; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  transform-origin: top left;
}
main {
  background: url('@/assets/images/bg/bg-personalcenter.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
}
.login-form {
  width: 800px;
  height: 600px;
  display: flex;
  padding: 200px 0;
}

.login-ui-bg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  position: relative;
  border-radius: 26px;
  background-color: #eee;
  box-shadow: 0 0 10px #ccc;
}
.login-ui-bg::before {
  content: '';
  display: block;
  width: 251px;
  height: 192px;
  position: absolute;
  top: 0;
  right: 0;
  background: url('@/assets/images/bg/bg-red.png') no-repeat;
  background-size: 100% 100%;
}
.login-ui-bg::after {
  content: '';
  display: block;
  width: 259px;
  height: 170px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: url('@/assets/images/bg/bg-blue.png') no-repeat;
  background-size: 100% 100%;
}

.sign-in-btn {
  width: 100%;
}
.sign-up-btn {
  color: #007bff;
  cursor: pointer;
  text-align: right;
  width: 100%;
}
.captcha-line {
  display: flex;
  gap: 10px;
  align-items: center;
}
.captcha-img {
  width: 120px;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.one-line {
  display: flex;
  gap: 10px;
}
.login-other {
  display: flex;
  gap: 10px;
}
</style>
